import { useIntl } from "react-intl";

import LogoImage from "../../../../assets/image/logo.svg";
import { NavbarViewProps } from "../types";
import * as Styled from "./styles";
import LinksMobile from "./NavLinks";

const MobileNavBar = (props: NavbarViewProps) => {
  const intl = useIntl();

  return (
    <Styled.Nav id="joyride-navbar-mobile" data-navbar-variant="mobile">
      <Styled.LogoButton type="button" onClick={props.onLogoClick}>
        <Styled.Logo src={LogoImage} alt="Logo Prática" />
      </Styled.LogoButton>

      <Styled.LinksViewport>
        <LinksMobile hidden={false} handleHideNavbar={props.handleHideNavbar} />
      </Styled.LinksViewport>

      <Styled.UpdateArea>
        <button className="cache" type="button" onClick={props.onClearCache}>
          {intl.formatMessage({ id: "menus.Clique para atualizar" })}
        </button>
        <button className="version" type="button" onClick={props.onClearCache}>
          {intl.formatMessage({ id: "menus.Versão" })}: 1.29.0
        </button>
      </Styled.UpdateArea>
    </Styled.Nav>
  );
};

export default MobileNavBar;
